let lastError = '';
let lastErrorTime = 0;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function checkIgnore(isUncaught: boolean, args: any[], payload: any) {
  // apply same debouncing logic as reportErrorDebounced for uncaught errors
  if (isUncaught) {
    const now = Date.now();
    const msg = payload?.data?.body?.trace?.exception?.message;

    if (msg === lastError && now - lastErrorTime < 5000) {
      return true;
    }

    lastError = msg;
    lastErrorTime = now;
  }
  return false;
}
